var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0,
    d: "M0 0H70V70H0z",
    transform: "translate(-685.000000, -316.000000) translate(430.000000, 284.000000) translate(255.000000, 32.001200)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(-685.000000, -316.000000) translate(430.000000, 284.000000) translate(255.000000, 32.001200) translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#365E7D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B4D66",
    d: "M58 28.5C58 12.76 44.991 0 28.944 0 28.29 0 27.643.023 27 .065c14.464.937 26.035 12.255 27.04 26.428.068.963-.736 1.76-1.72 1.74-.151-.004-.302-.005-.454-.005-11.984 0-21.699 9.528-21.699 21.283 0 1.103.086 2.187.252 3.246.327 2.092-1.222 4.032-3.375 4.175l-.044.003c.643.042 1.29.065 1.944.065C45.086 57 58 44.135 58 28.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 28,
    r: 22,
    fill: "#F4FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAF1F4",
    d: "M51 28c0-12.15-9.945-22-22.213-22-.601 0-1.197.024-1.787.071 11.474.905 20.492 10.445 20.425 22.058l-.002.001c-9.372 1.826-16.363 9.565-17.308 18.8-.162 1.588-1.417 2.858-3.023 2.991L27 49.93C39.934 50.949 51 40.857 51 28z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#365E7D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 3.574c-.585 0-1.059-.469-1.059-1.047v-1.48C17.941.469 18.415 0 19 0s1.059.469 1.059 1.047v1.48c0 .578-.474 1.047-1.06 1.047zM30.628 8.336c-.271 0-.542-.103-.75-.307-.413-.409-.413-1.072 0-1.48l1.06-1.047c.413-.409 1.083-.409 1.497 0 .414.409.414 1.072 0 1.48L31.376 8.03c-.206.204-.477.307-.748.307zM36.941 19.832h-1.497c-.585 0-1.059-.47-1.059-1.047 0-.579.474-1.047 1.06-1.047h1.496c.585 0 1.059.468 1.059 1.047 0 .578-.474 1.047-1.059 1.047zM19.435 38c-.584 0-1.058-.469-1.058-1.047v-1.48c0-.578.474-1.047 1.058-1.047.585 0 1.06.469 1.06 1.047v1.48c0 .578-.475 1.047-1.06 1.047zM6.314 32.374c-.271 0-.542-.102-.75-.307-.413-.409-.413-1.071 0-1.48l1.06-1.047c.413-.408 1.083-.408 1.497 0 .414.41.414 1.072 0 1.481l-1.058 1.046c-.207.205-.478.307-.75.307zM2.556 19.832H1.059c-.585 0-1.059-.47-1.059-1.047 0-.579.474-1.047 1.059-1.047h1.497c.585 0 1.059.468 1.059 1.047 0 .578-.474 1.047-1.06 1.047zM7.372 8.336c-.27 0-.542-.103-.749-.307L5.565 6.983c-.414-.41-.414-1.072 0-1.481.413-.409 1.084-.409 1.497 0l1.059 1.046c.414.409.414 1.072 0 1.48-.207.205-.478.308-.749.308z",
    transform: "translate(10.000000, 9.000000)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2B4D66",
    d: "M28.913 30c-.278 0-.552-.103-.76-.297l-3.824-3.585c-.43-.403-.44-1.066-.02-1.48.418-.414 1.107-.423 1.537-.02l1.979 1.855v-7.426c0-.578.487-1.047 1.087-1.047.601 0 1.088.469 1.088 1.047v9.906c0 .421-.262.8-.665.965-.136.055-.28.082-.422.082z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 49,
    r: 18,
    fill: "#DC0020"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB0019",
    d: "M52.064 31c-.698 0-1.387.041-2.064.12 8.933 1.027 15.871 8.64 15.871 17.88 0 9.24-6.938 16.853-15.871 17.88.678.079 1.366.12 2.064.12C61.97 67 70 58.941 70 49s-8.03-18-17.936-18z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F4FBFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 16.834c-1.105 0-2-.946-2-2.112V2.112C0 .946.895 0 2 0s2 .946 2 2.112v12.61c0 1.166-.895 2.112-2 2.112zM2 25c-1.105 0-2-.946-2-2.112v-1.345c0-1.167.895-2.112 2-2.112s2 .945 2 2.112v1.345C4 24.054 3.105 25 2 25z",
    transform: "translate(49.000000, 37.000000)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#DAF1F4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0C.635 0 .294.105 0 .285.597.65 1 1.33 1 2.112v12.61c0 .78-.403 1.462-1 1.827.294.18.635.285 1 .285 1.104 0 2-.946 2-2.112V2.112C3 .946 2.104 0 1 0zM1 19.43c-.365 0-.706.105-1 .285.597.366 1 1.046 1 1.828v1.345c0 .781-.403 1.462-1 1.827.294.18.635.285 1 .285 1.104 0 2-.946 2-2.112v-1.345c0-1.167-.896-2.112-2-2.112z",
    transform: "translate(50.000000, 37.000000)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.cbcfbd85.svg";
export { ForwardRef as ReactComponent };